import { useAuth } from './use-auth';

export default function CheckAuth({ roles = [], skipReadOnlyCheck = false, children }) {

    const { user } = useAuth();
    const isAuthorizedRole = !roles.length || roles.includes(user.roleName);
    const show = isAuthorizedRole && (skipReadOnlyCheck || !user.isReadOnly);

    return show ? children ?? null : null;
}